import { from_YYYYMMDDHHMMSS } from "../config/dateFormatting";
import { IReverseDutchAuctionPriceModelParameters, ISeatingContent } from "../planEatApi/PlanEatFacade";


export function reverseDutchAuctionPrice(parameters: IReverseDutchAuctionPriceModelParameters, seating: ISeatingContent){
    // Correct for cutoff
    var tmpSeatingTime = new Date(from_YYYYMMDDHHMMSS(seating.seatingStart))
    tmpSeatingTime.setDate(tmpSeatingTime.getDate() - parameters.cutOffDaysBefore)
    let [aHours,aMinutes] = parameters.cutOffTimeADay.split(":")
    tmpSeatingTime.setHours(parseInt(aHours))
    tmpSeatingTime.setMinutes(parseInt(aMinutes))

    // Time differemce
    var now = new Date()
    var difference = tmpSeatingTime.getTime() - now.getTime();
    var seconds = Math.floor(difference / 1000);
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);


    var currentPrice = Number.MAX_VALUE;
    parameters.pricePoints.forEach(pricePoint => {
        if(hours >= pricePoint.cutOffHour && currentPrice > pricePoint.price){
            currentPrice = pricePoint.price
        }
    })

    if(currentPrice=== Number.MAX_VALUE){
        currentPrice = 0;
    }

    return currentPrice
}